import Head from "next/head";
import { type FC } from "react";

const AuthorBlog: FC<{
  author: {
    name: string;
    username: string;
    followers: { id: string }[];
  };
}> = ({ author }) => {
  return (
    <Head>
      <title>{`${author?.name || ""}'s Blog - DB News Cloud`}</title>
      <meta name="description" content={`${author?.name || ""}&apos;s Blog`} />

      {/* Open Graph tags for social media banner */}
      <meta property="og:title" content={`${author?.name || ""}&apos;s Blog`} />
      <meta
        property="og:description"
        content={`${author?.name || ""}&apos;s Blog - DB News Cloud`}
      />
      <meta property="og:site_name" content={author?.name}></meta>
      <meta property="og:type" content="Author Blog"></meta>
      <meta
        property="og:url"
        content={`${process.env.NEXT_PUBLIC_VERCEL_URL as string}/dev/@${author?.username || ""
          }`}
      />

      {/* Twitter card tags for Twitter banner */}
      <meta
        name="twitter:title"
        content={`${author?.name || ""}&apos;s Blog - DB News Cloud`}
      />
      <meta
        name="twitter:description"
        content={`${author?.name || ""}&apos;s Blog on DB News Cloud.`}
      />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Other necessary tags */}
      <link
        rel="canonical"
        href={`${process.env.NEXT_PUBLIC_VERCEL_URL as string}/dev/@${author?.username || ""
          }`}
      />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Image tags */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/favicon.ico" />
    </Head>
  );
};

export default AuthorBlog;
